import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=5ea08462&scoped=true"
import script from "./Email.vue?vue&type=script&lang=js"
export * from "./Email.vue?vue&type=script&lang=js"
import style0 from "./Email.vue?vue&type=style&index=0&id=5ea08462&prod&scoped=true&lang=css"
import style1 from "./Email.vue?vue&type=style&index=1&id=5ea08462&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea08462",
  null
  
)

export default component.exports